import { FC } from 'react'

import usePrinter from 'src/hooks/usePrinter'
import SidebarContainer from './SidebarContainer'
import SidebarFooter from './SidebarFooter/SidebarFooter'
import SidebarProducts from './SidebarProducts/SidebarProducts'

const Sidebar: FC = () => {
  const { printMode } = usePrinter()
  if (printMode) {
    return null
  }
  return (
    <SidebarContainer>
      <SidebarProducts />
      <SidebarFooter />
    </SidebarContainer>
  )
}

export default Sidebar
